import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Paper, withStyles, Typography, IconButton, Tooltip, Box } from '@material-ui/core';
import { Payment, CloudDownload } from '@material-ui/icons';
import { connect } from 'react-redux';
import CustomerEdit from './CustomerEdit'
import CustomerErasures from './CustomerErasures'
import moment from 'moment/moment.js'
import { parseURL, BackButton, downloadFile, hasPermission, formatDate } from '../../../sc-utilities';
import * as actions from '../store/customerActions';
import AccountSection from './AccountSection';
import * as billingActions from '../../../sc-billing/BillingAccount/store/billingAccountActions';
import * as deliveryNoteActions from '../store/deliveryNoteActions';
import { snackActions } from '../../../sc-utilities/SnackBar';
import { updateURL } from "../../../sc-utilities";
import * as action from '../../../np-core/Auth/store/authActions';
import DeliveryNoteBill from "./DeliveryNoteBill";
import { CancelToken } from 'axios';
import DeliveryNotesList from './DeliveryNotesList';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        paddingTop: 0,
        paddingRight: theme.spacing(2),
        paddingBottom: 0,
        margin: theme.spacing(2),
        marginBottom: theme.spacing(0),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
        paper: {
            backgroundColor: "transparent",
            boxShadow: "none",
            overflow: "hidden",
        },
        logo: {
            width: '250px',
            height: '100%'
        },
    },
});
const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}
const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={{ paddingTop: 1, paddingLeft: 3 * 3, paddingRight: 3 * 3, bottom: -6 }} scroll='paper'>
            {props.children}
        </Typography>
    );
};

const getTabValue = () => {
    let urlArray = window.location.href.split('#');
    return urlArray.length > 1 ? Number(urlArray[1]) : 0;
};

const CustomerDetails = props => {
    const tableRef = React.useRef();
    const { onCreateBillingAccount, createDeliveryNote, account, onDeleteBillingAccount, onSuspend, onListUsers, onRecover, onListCustomers, onDownloadReport, onFetchLogos, fetchDeliveryNotesCount, onFetchCustomers, classes, customers, activeCustomer, onUpdateCustomer, onEditCustomer, onCleanState, translations, permissions, onLoadYears, onLoadErasures, onLoadCustomer, deliveryNotes, columns, saveColumnsFilter, fetchDeliveryNotes, billDeliveryNote } = props;

    const [tabValue, setTabValue] = useState(getTabValue());
    const [id, setId] = useState();
    const [loading, setLoading] = useState(false);
    const [years, setYears] = useState([]);
    const [year, setYear] = useState(moment().year() + '');
    const [erasures, setErasures] = useState({ erasure: [], loading: false });
    const [billDeliveryNoteState, setBillDeliveryNoteState] = useState({
        open: false,
        billingAccountID: null,
        billingAccountIDs: [],
        forBulk: false
    });

    const [downloading, setDownloading] = useState({});

    let searchParams = parseURL(window.location.search);
    const isMounted = React.useRef(true);

    const customerCancel = CancelToken?.source();
    const yearsCancel = CancelToken?.source();
    const erasuresCancel = CancelToken?.source();

    useEffect(() => {
        if (isMounted.current) {
            setLoading(customers.loading || customers.editing);
            setLoading(false);
        }
        return () => {
            onCleanState();

        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customers.loading, customers.editing, isMounted]);


    const downloadDeliveryNote = async (runningID, originalFileName) => {
        setDownloading({ [runningID]: true })
        let file = await onDownloadReport(runningID);
        if (file) {
            setDownloading({ [runningID]: false })
            return downloadFile(file, originalFileName);
        }
        setDownloading({ [runningID]: false })
        snackActions.snackBarComponent(translations['not_find_delivery'] || 'Could not find delivery report!', 'error');
    };

    const handleDeliveryNoteBill = async (event, ID) => {
        setLoading(true);
        if (!event) {
            setBillDeliveryNoteState({ open: false, deliveryNoteID: null });
            setId(null);
            return;
        }
        setId(ID);
        setBillDeliveryNoteState({ ...billDeliveryNoteState, open: true, deliveryNoteID: id });
        setLoading(false);
    };

    useEffect(() => {

        const fetchData = async () => {
            if (!customers.account.loading) {
                if (isMounted.current || (isMounted.current && loading)) {
                    let counter = 0;
                    let customerData = [];
                    setErasures({
                        erasure: customerData,
                        loading: true
                    });

                    if (!years.length) {
                        const years = await onLoadYears({ CustomerID: searchParams.customerID, ActiveCustomerID: activeCustomer }, { cancelToken: yearsCancel });
                        setYears(years);
                    }

                    const data = await onLoadErasures({ CustomerID: searchParams.customerID, Year: year, ActiveCustomerID: activeCustomer }, { cancelToken: erasuresCancel });

                    for (var erasure in data) {
                        let returnObj = {};
                        returnObj.id = erasure;
                        returnObj.index = counter;
                        returnObj.selected = false;
                        returnObj.visible = true;
                        returnObj.values = [erasure, data[erasure].pc + data[erasure].mobile + data[erasure].storage, data[erasure].pc, data[erasure].mobile, data[erasure].storage];
                        counter++;
                        customerData.push(returnObj);
                    };
                    isMounted?.current && setErasures({
                        erasure: customerData,
                        loading: false
                    });
                }
            };
        }

        isMounted.current && setLoading(false);
        isMounted.current && onLoadCustomer({ CustomerID: searchParams.customerID, ActiveCustomerID: activeCustomer }, { cancelToken: customerCancel });
        isMounted.current && fetchData();

        return () => {
            customerCancel.cancel('Operation canceled by user');
            yearsCancel.cancel('Operation canceled by the user.');
            erasuresCancel.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customers.account.loading, activeCustomer, id, customers.edited, onLoadCustomer, searchParams.customerID, onLoadYears, onLoadErasures, year, account.creating, account.deleting]);

    const handleChange = (event, value) => {
        updateURL(value);
        setTabValue(value);
    };

    let visible = columns && columns['Customer'];

    const tableColumns = React.useMemo(() => {
        return [
            {
                title: translations["action"] || "Action", field: 'Action',
                hidden: visible ? visible['Action'] : false,
                cellStyle: { minWidth: 100, maxWidth: 100 },
                filtering: false,
                render: rowData => <>
                    {
                        hasPermission(permissions, 'delivery_note_charge') ? <Tooltip title={translations["charge_delivery_note"] || "Charge delivery note"}>
                            <IconButton
                                disabled={rowData.Billed}
                                id={`delivery_note_charge${rowData.DeliveryNoteID}`}
                                component='div'
                                onClick={() => handleDeliveryNoteBill(rowData.DeliveryNoteID)}
                            >
                                <Payment />
                            </IconButton>
                        </Tooltip>
                            : null
                    }

                    {
                        hasPermission(permissions, 'delivery_note_download') ? <Tooltip title={translations["download_note_list"] || "Download note list"}>
                            <IconButton id={`delivery_note_download${rowData.DeliveryNoteID}`}
                                component='div'
                                onClick={() => downloadDeliveryNote(rowData.DeliveryNoteID, `DeliveryNote${rowData.DeliveryNoteID}.pdf`)}
                            >
                                <CloudDownload />
                            </IconButton>
                        </Tooltip> : null
                    }
                </>

            },
            {
                title: translations["running_id"] || 'Running ID', field: 'RunningID',
                hidden: visible ? visible['RunningId'] : false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.RunningID ? rowData.RunningID : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["generated_at"] || 'Generated At', field: 'generated_at',
                hidden: visible ? visible['CreatedAt'] : false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.CreatedAt ? moment(rowData.CreatedAt).format('DD.MMM.YYYY') : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations['billed'] || 'Billed', field: 'Billed',
                hidden: visible ? visible['Billed'] : false,
                lookup: { '0': translations['no'] || 'No', '1': translations['yes'] || 'Yes' },
                defaultFilter: ['0', '1'],
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Billed ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
                }
            },
            {
                title: translations["billed_date"] || 'Billed date', field: 'BilledDate',
                hidden: visible ? visible['BilledDate'] : false,
                type: 'date',
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.CreatedAt ? formatDate(rowData.CreatedAt) : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classes, translations, visible, handleDeliveryNoteBill]);

    return (
        <>
            <Paper className={classes.root}>
                {BackButton(translations)}
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    {hasPermission(permissions, 'customer_load') ? <Tab label={translations['details'] || "Details"} /> : null}
                    {hasPermission(permissions, 'billing_account_list') ? <Tab label={translations['accounts'] || "Accounts"} /> : null}
                    {hasPermission(permissions, 'delivery_note_list') ? <Tab disabled={customers?.loaded?.Accounts?.length <= 0} label={translations['delivery_notes'] || "Delivery notes"} /> : null}
                    {hasPermission(permissions, 'customer_erasure_list') ? <Tab label={translations['erasures'] || "Erasures"} /> : null}
                </Tabs>
            </Paper>
            <DeliveryNoteBill billDeliveryNote={billDeliveryNote}
                activeCustomer={activeCustomer}
                fetchDeliveryNotes={fetchDeliveryNotes}
                translations={translations}
                id={id}
                billDeliveryNoteModalState={billDeliveryNoteState}
                handleDeliveryNoteBill={handleDeliveryNoteBill} />
            <Paper className={classes.root}>
                <TabPanel index={0} value={tabValue}>
                    <TabContainer>
                        <CustomerEdit
                            onCleanState={onCleanState}
                            activeCustomer={activeCustomer} permissions={permissions} customerID={searchParams.customerID} customer={customers?.loaded}
                            translations={translations}
                            onFetchLogos={onFetchLogos}
                            userLanguage={props.userLanguage}
                            onUpdateCustomer={onUpdateCustomer}
                            setLoading={setLoading}
                            loading={loading} onEditCustomer={onEditCustomer}
                            onLoadCustomer={onLoadCustomer} />
                    </TabContainer>
                </TabPanel>
                <TabPanel index={1} value={tabValue}>
                    <TabContainer>
                        <AccountSection activeCustomer={activeCustomer}
                            onLoadCustomer={onLoadCustomer}
                            onFetchCustomers={onFetchCustomers}
                            onCleanState={onCleanState}
                            setLoading={setLoading}
                            loading={loading}
                            onDeleteBillingAccount={onDeleteBillingAccount}
                            customerID={searchParams.customerID}
                            onSuspend={onSuspend}
                            translations={translations}
                            onRecover={onRecover}
                            onListCustomers={onListCustomers}
                            onListUsers={onListUsers}
                            createBillingAccount={onCreateBillingAccount}
                            permissions={permissions}
                            accounts={customers.loaded ? customers.loaded.Accounts : []} />
                    </TabContainer>
                </TabPanel>
            </Paper>
            <TabPanel index={2} value={tabValue}>
                <TabContainer>
                    <DeliveryNotesList
                        activeCustomer={activeCustomer}
                        tableColumns={tableColumns}
                        DeliveryNoteID={id}
                        loading={loading}
                        columnsState={columns}
                        fetchDeliveryNotesCount={fetchDeliveryNotesCount}
                        translations={translations}
                        saveColumnsFilter={saveColumnsFilter}
                        CustomerID={searchParams.customerID}
                        deliveryNotes={deliveryNotes}
                        fetchDeliveryNotes={fetchDeliveryNotes}
                        permissions={permissions}
                        downloadDeliveryNote={downloadDeliveryNote}
                        downloading={downloading}
                        handleDeliveryNoteBill={handleDeliveryNoteBill}
                        createDeliveryNote={createDeliveryNote}
                        account={customers.loaded ? customers.loaded.Accounts : []}
                        tableRef={tableRef}
                    />
                </TabContainer>
            </TabPanel>
            <Paper className={classes.root}>
                <TabPanel index={3} value={tabValue}>
                    <TabContainer>
                        <CustomerErasures
                            columnsState={columns}
                            year={year}
                            isMounted={isMounted.current}
                            activeCustomer={activeCustomer}
                            saveColumnsFilter={saveColumnsFilter}
                            years={years}
                            setYear={setYear}
                            translations={translations}
                            erasures={erasures}
                            customer={customers.loaded} />
                    </TabContainer>
                </TabPanel>
                <DeliveryNoteBill billDeliveryNote={billDeliveryNote}
                    activeCustomer={activeCustomer}
                    fetchDeliveryNotes={fetchDeliveryNotes}
                    translations={translations}
                    id={id}
                    billDeliveryNoteModalState={billDeliveryNoteState}
                    handleDeliveryNoteBill={handleDeliveryNoteBill} />
            </Paper>
        </>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        customers: state?.customer?.customers,
        translations: state?.translate?.translations?.activeTranslations || {},
        columns: state?.core?.login?.userSettings?.Columns || null,
        account: state?.billing?.accounts,
        deliveryNotes: state?.customer?.deliveryNotes,
        permissions: state?.core?.login?.permissions || [],
        userLanguage: state?.core?.login?.userSettings?.DefaultLanguage,

    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLoadCustomer: (customerID, options) => dispatch(actions.loadCustomer(customerID, options)),
        onFetchCustomers: customerID => dispatch(actions.fetchCustomers(customerID)),
        onFetchLogos: (id) => dispatch(actions.fetchLogos(id)),
        onEditCustomer: customerID => dispatch(actions.editCustomer(customerID)),
        onUpdateCustomer: (customer, options) => dispatch(actions.updateCustomer(customer, options)),
        onLoadYears: customerID => dispatch(actions.fetchYears(customerID)),
        onLoadErasures: customerID => dispatch(actions.fetchErasures(customerID)),
        onRecover: billingAccountID => dispatch(actions.recoverBillingPlan(billingAccountID)),
        onSuspend: billingAccountID => dispatch(actions.suspendBillingPlan(billingAccountID)),
        onCreateBillingAccount: billingAccount => dispatch(billingActions.createBillingAccount(billingAccount)),
        onDeleteBillingAccount: billingAccount => dispatch(billingActions.deleteBillingAccount(billingAccount)),
        onListCustomers: (options) => dispatch(billingActions.listCustomers(options)),
        onListUsers: (id, options) => dispatch(billingActions.listUsers(id, options)),
        onCleanState: () => dispatch(actions.cleanState()),
        fetchDeliveryNotes: (params, options) => dispatch(deliveryNoteActions.fetchDeliveryNotes(params, options)),
        fetchDeliveryNotesCount: (params, options) => dispatch(deliveryNoteActions.fetchDeliveryNotesCount(params, options)),
        createDeliveryNote: params => dispatch(deliveryNoteActions.createDeliveryNote(params)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        onDownloadReport: deliveryNoteID => dispatch(deliveryNoteActions.downloadPdf(deliveryNoteID)),
        billDeliveryNote: (deliveryNoteID, options) => dispatch(deliveryNoteActions.billDeliveryNote(deliveryNoteID, options)),
        updatePresets: (params, options) => dispatch(actions.updatePresets(params, options)),
        fetchOrders: (id, options) => dispatch(actions.fetchOrders(id, options)),
        fetchCollies: (id, options) => dispatch(actions.fetchCollies(id, options)),
        fetchPrinters: (id, options) => dispatch(actions.fetchPrinters(id, options)),
        fetchGrades: (id, options) => dispatch(actions.fetchGrades(id, options)),
        updateCustomerStore: params => dispatch(actions.updateCustomerStore(params)),
        onFetchErasureMethods: (user) => (dispatch(actions.fetchErasureMethod(user))),
        fetchOperatingSystems: (params, options) => dispatch(actions.fetchOperatingSystems(params, options))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(CustomerDetails));